export type Coordinates = {
  readonly lat: number;
  readonly lng: number;
};

export function createCoordinates(values: unknown): Coordinates {
  const { lat, lng } = values as Coordinates;

  return {
    lat,
    lng,
  };
}
